import React from 'react';

export default function Brand({ size = 'sm' }) {
  return (
    <div className="login-brand">
      <div className="login-brand-mark">T</div>
      <div className="login-brand-name">Transcript{size === 'lg' ? ' · Diplo AI' : ''}</div>
    </div>
  );
}
